export const forms = {
  language: "Sprache",
  exhibitor: "Hauptaussteller",
  gender: "Anrede",
  salutation: "Anrede",
  title: "Titel",
  firstName: "Vorname",
  lastName: "Nachname",
  phone: "Telefon",
  mobile: "Handynummer",
  mobilePhone: "Handynummer",
  fax: "Fax",
  department: "Abteilung",
  position: "Position",
  company: "Firma",
  company1: "Firma",
  company2: "Firma 2",
  company3: "Firma 3",
  street: "Straße",
  companyStreet: "Straße",
  houseNumber: "Hausnr.",
  companyStreetNo: "Hausnr.",
  street2: "Straße 2",
  company2Street: "Straße 2",
  houseNumber2: "Hausnr. 2",
  company2StreetNo: "Hausnr. 2",
  zip: "PLZ",
  companyZipCode: "PLZ",
  city: "Ort",
  companyCity: "Ort",
  companyRegion: "Region",
  country: "Land",
  companyCountryCodeId: "Land",
  website: "Internet / Website",
  companyWebsite: "Internet / Website",
  email: "E-Mail",
  companyEmail: "E-Mail Firma allgemein",
  companyType: "Art des Betriebs",
  nomenclature: "Element hinzufügen",
}
